import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { DEFAULT_COVER_SETTINGS } from 'editor/components/CoverPage/config';

// 創建記憶化的選擇器
const selectCoverSetting = createSelector(
    [state => state.settingGameStyle?.coverSetting || {}],
    coverSetting => ({
        ...DEFAULT_COVER_SETTINGS,
        ...coverSetting
    })
);

export default function useCoverSettingComponentStyle() {
    // 使用記憶化的選擇器
    return useSelector(selectCoverSetting);
}
